module.exports = __webpack_public_path__ + "static/media/roi-reduction-in-patient.886489fa.png";